module.exports = __webpack_public_path__ + "img/favicon.ffb79cd9.ico";